import { getOptionsByType, getSelector, defaultSelector } from './swiper-utils'

const selectors = {
  THRESHOLD_TO_RUN: 5,
  INTERVAL_TIMEOUT: 300
}

class SwiperInstanceComponent {
  constructor(element, options, config, type) {
    this.element = element
    this.selector = getSelector(this.element, defaultSelector.component.CAROUSEL_SWIPER_SELECTOR)
    this.options = getOptionsByType(this.element, options, config, type)
    this.swiper = document.querySelector(`.${this.selector}`, this.element)

    if (!this.swiper?.initialize || !this.swiper) {
      let count = 0

      const interval = setInterval(() => {
        count++

        if (count > selectors.THRESHOLD_TO_RUN) {
          clearInterval(interval)
        }

        if (this.swiper?.initialize) {
          clearInterval(interval)
          this.init()
        }
      }, selectors.INTERVAL_TIMEOUT)
    } else {
      this.init()
    }
  }

  init() {
    Object.assign(this.swiper, this.options)
    this.swiper.initialize()
  }
}

export default SwiperInstanceComponent
